export default __webpack_public_path__ + "static/clean-ingredients_real-people_Kaylah-Bell-183e98f327ecfbdc1cd313c935809d3c.png";